/**
 * Cache "stale-while-revalidate" SOLO IN MEMORIA per inbox e chat.
 *
 * Obiettivo: rientrando nell'inbox o riaprendo una chat già vista, mostrare
 * subito l'ultimo stato noto mentre il fetch reale gira in background → niente
 * schermata vuota / attesa percepita.
 *
 * Sicurezza:
 *  - Vive solo in memoria (modulo singleton). NIENTE localStorage/IDB.
 *    Sparisce a ogni reload/chiusura tab.
 *  - NON contiene testo in chiaro: i messaggi sono in ciphertext (come dal
 *    server); la decrittazione resta a ChatScreen con le chiavi in memoria.
 *    La lista inbox contiene solo metadati (sigil/timestamp/stato).
 *  - Namespacing per owner (firebaseUid): se cambia l'utente attivo la cache
 *    si invalida automaticamente → nessun "flash" delle chat dell'utente
 *    precedente dopo un cambio account. clearSessionCache() per il wipe.
 */

let _ownerUid = null;
let _chatList = null;            // ultimo array chat dell'inbox
const _chatById = new Map();     // chatId -> { chat, messages }

// Se l'owner cambia, azzera tutto (e adotta il nuovo owner).
function _checkOwner(uid) {
  if (uid && _ownerUid && uid !== _ownerUid) {
    _chatList = null;
    _chatById.clear();
  }
  if (uid) _ownerUid = uid;
}

export function getCachedChatList(ownerUid) {
  _checkOwner(ownerUid);
  return _chatList;
}
export function setCachedChatList(ownerUid, items) {
  _checkOwner(ownerUid);
  _chatList = Array.isArray(items) ? items : null;
}

export function getCachedChat(ownerUid, chatId) {
  _checkOwner(ownerUid);
  if (!chatId) return null;
  return _chatById.get(chatId) || null;
}
export function setCachedChat(ownerUid, chatId, data) {
  _checkOwner(ownerUid);
  if (!chatId || !data) return;
  _chatById.set(chatId, data);
}

/** Azzera tutto. Da chiamare al lock / logout / wipe. */
export function clearSessionCache() {
  _ownerUid = null;
  _chatList = null;
  _chatById.clear();
}
